import { Navigate, Outlet, useRoutes } from "react-router-dom";

import AuthGuard from "../auth/AuthGuard";
import GuestGuard from "../auth/GuestGuard";
import { PATH_AFTER_LOGIN } from "../config-global";
import Contacts from "../pages/contact/Contact";
import Menu from "../pages/menu/Menu";

import Projects from "../pages/project/Projects";
import Testimonial from "../pages/testimonial/testimonial";
import { Layout } from "../routers";
import {
  Banner,
  BookingList,
  EventBooking,
  EventGallery,
  EventType,
  HotelRoom,
  LoginPage,
  MyProfile,
  News,
  OverView,
  Package,
  RoomBooking,
  RoomRate,
  RoomType,
  Services,
} from "./elements";

//

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: "/",
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        {
          path: "login",
          element: (
            <GuestGuard>
              <LoginPage />
            </GuestGuard>
          ),
        },
      ],
    },

    {
      path: "/admin",
      element: (
        <AuthGuard>
          <Outlet />
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },

        {
          path: "overview",
          element: (
            <Layout>
              <OverView />
            </Layout>
          ),
        },
        {
          path: "services",
          element: (
            <Layout>
              <Services />
            </Layout>
          ),
        },
        {
          path: "news",
          element: (
            <Layout>
              <News />
            </Layout>
          ),
        },
        {
          path: "project",
          element: (
            <Layout>
              <Projects />
            </Layout>
          ),
        },
        {
          path: "events",
          element: (
            <Layout>
              <EventType />
            </Layout>
          ),
        },
        {
          path: "testimonial",
          element: (
            <Layout>
              <Testimonial />
            </Layout>
          ),
        },
        {
          path: "banner",
          element: (
            <Layout>
              <Banner />
            </Layout>
          ),
        },
        {
          path: "event-gallery",
          element: (
            <Layout>
              <EventGallery />
            </Layout>
          ),
        },
        {
          path: "menu",
          element: (
            <Layout>
              <Menu />
            </Layout>
          ),
        },

        {
          path: "event-booking",
          element: (
            <Layout>
              <EventBooking />
            </Layout>
          ),
        },
        {
          path: "bookings",
          element: (
            <Layout>
              <BookingList />
            </Layout>
          ),
        },
        {
          path: "room-types",
          element: (
            <Layout>
              <RoomType />
            </Layout>
          ),
        },

        {
          path: "hotel-rooms",
          element: (
            <Layout>
              <HotelRoom />
            </Layout>
          ),
        },

        {
          path: "room-booking",
          element: (
            <Layout>
              <RoomBooking />
            </Layout>
          ),
        },

        {
          path: "packages",
          element: (
            <Layout>
              <Package />
            </Layout>
          ),
        },

        {
          path: "room-rates",
          element: (
            <Layout>
              <RoomRate />
            </Layout>
          ),
        },

        {
          path: "my-profile",
          element: (
            <Layout>
              <MyProfile />
            </Layout>
          ),
        },

        {
          path: "contact",
          element: (
            <Layout>
              <Contacts />
            </Layout>
          ),
        },
      ],
    },

    // {
    //   // element: <CompactLayout />,
    //   children: [{ path: "404", element: <Page404 /> }],
    // },

    // { path: "*", element: <Navigate to="/404" replace /> },
  ]);
}
